import SuccessRoundImage from '../../assets/images/success-round.webp';
import useTranslation from '../../localization/i18n.context';
import SuccessFeedbackScreen from '../../components/shared/SuccessFeedbackScreen/SuccessFeedbackScreen';
import { useEffect } from 'preact/hooks';
import NavigationUtils from '../../utils/navigation.utils';
import { TrackingEvent } from '../../sdk/tracking.event';

export default function ReportCardSuccessPage({
  organization: organizationCode,
}) {
  const { t, getOrganization } = useTranslation();

  const closeFlow = () => {
    NavigationUtils.endFlow();
  };

  const goToPickupLocation = () => {
    NavigationUtils.navigate(NavigationUtils.Routes.PICKUP);
  };

  useEffect(() => {
    TrackingEvent.trigger(
      TrackingEvent.Events.REPORT_CARD_REPRINT_CONFIRMATION_SHOW,
      TrackingEvent.Sources.CAAS,
    );
  }, []);
  return (
    <SuccessFeedbackScreen
      onCloseClick={closeFlow}
      image={SuccessRoundImage}
      title={t('Your new card is ready to be picked up')}
      text={t('Your current card was cancelled')}
      subtitle={t(
        'Visit a {card name} pick up point to collect and activate your new card',
        { '{card name}': getOrganization(organizationCode) },
      )}
      ctaAction={goToPickupLocation}
      ctaText={t('See pick up locations')}
    />
  );
}
